import React from 'react';

import cx from 'classnames';

import itemStyles from 'components/Pages/Admin/GuestPortal/Flights/FlightsTable/index.module.css';
import { getMinutesAndHoursFormat } from 'components/Pages/Admin/GuestPortal/Flights/utils';
import i18n from 'i18n';
import { formatDate } from 'utils/date';
import { getTranslationDateFormat } from 'utils/i18n/date';

import s from './index.module.css';

export function TransferTop(props) {
  const {
    departureTime,
    departureFrom,
    bookedBy,
    confirmationNumber,
    provider,
    contactInformation,
    duration,
    arrivalTo,
    departureTimeEmpty,
  } = props;
  const needShowTime = !departureTimeEmpty;

  return (
    <div className={cx(itemStyles.blockItem, itemStyles.details)}>
      <strong>
        {i18n.t('proposal_content.event_details.transfers.from_to', {
          from: departureFrom,
          to: arrivalTo,
        })}
      </strong>
      <div className={s.timeText}>
        {i18n.t('proposal_content.event_details.transfers.departures.time')}:{' '}
        {needShowTime ? getMinutesAndHoursFormat(new Date(departureTime), null, ':') : i18n.t('proposal_content.tbd')}
      </div>

      <div className={s.detailsContainer}>
        {bookedBy && <div>{`${i18n.t('proposal_content.event_details.booked_by')}: ${bookedBy}`}</div>}
        {confirmationNumber && (
          <div>{`${i18n.t('proposal_content.event_details.confirmation_number')}: ${confirmationNumber}`}</div>
        )}
        {provider && <div>{`${i18n.t('proposal_content.event_details.provider')}: ${provider}`}</div>}
        {contactInformation && (
          <div>{`${i18n.t('proposal_content.event_details.contact_info')}: ${contactInformation}`}</div>
        )}
        {duration && <div>{`${i18n.t('proposal_content.event_details.duration')}: ${duration}`}</div>}
      </div>
    </div>
  );
}

export function TransferBottom(props) {
  const { arrivalTo, arrivalTime, arrivalTimeEmpty, departureTime, dateFormat } = props;
  const time = new Date(arrivalTime);
  const isSameDate = formatDate(time) === formatDate(new Date(departureTime));
  const needShowTime = !arrivalTimeEmpty;

  return (
    <div className={cx(itemStyles.blockItem, itemStyles.details)}>
      <strong>{`${i18n.t('proposal_content.event_details.transfers.arrivals.in')} ${arrivalTo}`}</strong>
      <div className={s.timeText}>
        {!isSameDate && (
          <>
            {i18n.t('proposal_content.event_details.transfers.arrivals.day')}:{' '}
            {i18n.strftime(time, getTranslationDateFormat(dateFormat))}
            <br />
          </>
        )}
        {i18n.t('proposal_content.event_details.transfers.arrivals.time')}:{' '}
        {needShowTime ? getMinutesAndHoursFormat(time, null, ':') : i18n.t('proposal_content.tbd')}
      </div>
    </div>
  );
}
